export enum TripMonthType {
  FromCurrentMonth = 0,
  FromTripStart = 1,
  FromTripEnd = 2,
}
